import axios from 'axios'

export default new class ProjectService {
  get (projectId) {
    return axios.get('/projects/' + projectId)
  }

  getList () {
    return axios.get('/projects',)
  }

  new (name) {
    return axios.post('/projects',{name})
  }

  delete (projectId) {
    return axios.delete('/projects/' + projectId)
  }
}()
